import { extend } from 'lodash';
import { getSsoUrl } from 'client/applications/utils/ApplicationUtils';
import { mapState } from 'vuex';
import { notify } from 'client/util/index';
import Constants, { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';

const { success } = Constants;
const applicationModel = StoreModelMap[ItemTypeConsts.application];

export default {
  computed: {
    ...mapState(applicationModel, [
      'item',
    ]),

    appmModelConfig() {
      return extend(
        {
          idpCertificate: {},
          idpPrivateKey: {},
        },
        this.item.config,
      );
    },

    appmHasIdpCertificate() {
      return !!this.appmModelConfig.idpCertificate.value;
    },

    appmIdpCertificate() {
      return atob(this.appmModelConfig.idpCertificate.value);
    },

    appmIdpCertificateDownloadName() {
      return 'certificate.pem';
    },
  },

  methods: {
    generateBlobUrl(content, name) {
      return window.URL.createObjectURL(
        new Blob([content], { type: 'application/pem-certificate-chain' }, name),
      );
    },

    downloadFile(url, name) {
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = name;

      document.querySelector('body').append(a);
      a.click();

      window.URL.revokeObjectURL(url);
      a.remove();
    },

    downloadIdpCertificate() {
      const url = this.generateBlobUrl(
        this.appmIdpCertificate,
        this.appmIdpCertificateDownloadName,
      );
      this.downloadFile(url, this.appmIdpCertificateDownloadName);
      notify(success, 'Successfully downloaded certificate');
    },

    copyUrlToClipboard(endpoint) {
      const ssoUrl = getSsoUrl();

      if (navigator.clipboard) {
        navigator.clipboard.writeText(ssoUrl + endpoint);
        return;
      }

      // IE11 support for clipboard
      if (window.clipboardData) {
        window.clipboardData.setData(ssoUrl + endpoint);
      }
    },
  },
};
